const defaultFields = {
  selected: {
    order: 1, visible: true, maxWidth: 38, minWidth: 38, defaultMin: 38, locked: true
  },
  severity: {
    order: 3, visible: true, maxWidth: 45, minWidth: 45, defaultMin: 45, locked: true
  },
  confirmed: {
    order: 2, visible: true, maxWidth: 39, minWidth: 39, defaultMin: 39, locked: true
  },
  name: {
    order: 5, visible: true, maxWidth: 600, minWidth: 200, defaultMin: 400, locked: true
  },
  workspace_name: {
    order: 4, visible: true, maxWidth: 200, minWidth: 120, defaultMin: 120, locked: true
  },
  risk: {
    order: 6, visible: true, maxWidth: 80, minWidth: 78, defaultMin: 78, locked: true
  },
  status_history: {
    order: 7, visible: false, maxWidth: 500, minWidth: 140, defaultMin: 140
  },
  asset: {
    order: 8, visible: true, maxWidth: 150, minWidth: 120, defaultMin: 120
  },
  cvss: {
    order: 9, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  cve: {
    order: 11, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  cwe: {
    order: 12, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  hostnames: {
    order: 13, visible: true, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  create_date: {
    order: 14, visible: true, maxWidth: 150, minWidth: 150, defaultMin: 150
  },
  service__name: {
    order: 15, visible: true, maxWidth: 150, minWidth: 120, defaultMin: 120
  },
  tool: {
    order: 16, visible: true, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  creator_command_id: {
    order: -1, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  status: {
    order: 17, visible: true, maxWidth: 110, minWidth: 110, defaultMin: 110
  },
  tags: {
    order: 18, visible: true, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  id: {
    order: -1, visible: false, maxWidth: 70, minWidth: 70, defaultMin: 70
  },
  host__os: {
    order: -1, visible: false, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  easeofresolution: {
    order: -1, visible: false, maxWidth: 170, minWidth: 170, defaultMin: 170
  },
  website: {
    order: -1, visible: false, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  path: {
    order: -1, visible: false, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  status_code: {
    order: -1, visible: false, maxWidth: 150, minWidth: 150, defaultMin: 150
  },
  evidence: {
    order: -1, visible: false, maxWidth: 100, minWidth: 100, defaultMin: 100
  },
  impact: {
    order: -1, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  description: {
    order: -1, visible: false, maxWidth: 500, minWidth: 250, defaultMin: 250
  },
  data: {
    order: -1, visible: false, maxWidth: 500, minWidth: 250, defaultMin: 250
  },
  request: {
    order: -1, visible: false, maxWidth: 500, minWidth: 250, defaultMin: 250
  },
  response: {
    order: -1, visible: false, maxWidth: 500, minWidth: 250, defaultMin: 250
  },
  resolution: {
    order: -1, visible: false, maxWidth: 500, minWidth: 250, defaultMin: 250
  },
  method: {
    order: -1, visible: false, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  query: {
    order: -1, visible: false, maxWidth: 350, minWidth: 250, defaultMin: 250
  },
  web: {
    order: -1, visible: false, maxWidth: 50, minWidth: 50, defaultMin: 50
  },
  external_id: {
    order: -1, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  issuetracker: {
    order: -1, visible: false, maxWidth: 340, minWidth: 140, defaultMin: 140
  },
  owasp: {
    order: -1, visible: false, maxWidth: 120, minWidth: 120, defaultMin: 120
  },
  update_date: {
    order: -1, visible: false, maxWidth: 150, minWidth: 150, defaultMin: 150
  },
  last_detected: {
    order: -1, visible: false, maxWidth: 150, minWidth: 150, defaultMin: 150
  }
};

export default defaultFields;
